// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"K1-z","displaySixCardTiles":"L1-z"};